import { Box } from '@aicon-dev/caas-core';
import { theme } from '@aicon-dev/caas-ui/dist/theme.css';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { BiErrorCircle } from 'react-icons/bi';
import styled from 'styled-components';

import {
  Weather_Cloud,
  Weather_Gray,
  Weather_Rain,
  Weather_Snow,
  Weather_Sun,
} from '~/assets/icons';

import { IDashboardWeathers } from '../../libs/types';

interface Props {
  weather: IDashboardWeathers;
}

export const WeatherListItem = ({ weather }: Props) => {
  const { t } = useTranslation('project_dashboard');

  const formattedDate = dayjs(weather.fcstDate).format('MM.DD dd');

  const isToday = dayjs(weather.fcstDate).format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD');

  const renderWeatherIcon = (code: string) => {
    const getWeatherIcon = () => {
      switch (code) {
        case 'SKY_001':
          return <Weather_Sun width={'32px'} height={'32px'} />;

        case 'SKY_003':
          return <Weather_Cloud width={'32px'} height={'32px'} />;

        case 'SKY_004':
          return <Weather_Rain width={'32px'} height={'32px'} />;

        case 'SKY_005':
          return <Weather_Snow width={'32px'} height={'32px'} />;

        case 'SKY_007':
          return <Weather_Gray width={'32px'} height={'32px'} />;

        default:
          return <BiErrorCircle color="#aab6c3" width={'32px'} height={'32px'} />;
      }
    };

    return getWeatherIcon();
  };

  return (
    <Box>
      {isToday && (
        <Box
          width="fit-content"
          padding="4px 16px"
          marginBottom="8px"
          borderRadius="6px"
          background={theme.color.primary[500]}
          color="#fff"
          position={'absolute'}
        >
          {t('project_dashboard:m_today')}
        </Box>
      )}

      <Box margin="0 8px 0 -8px">
        <WeatherItemWrapper>
          <Box marginBottom="4px" color={'#333'} fontWeight={500}>
            {formattedDate}
          </Box>
          <Box>{renderWeatherIcon(weather.skyCode)}</Box>
          <Box display={'flex'} alignItems={'center'} style={{ gap: '0.25rem' }}>
            <Box color={'#1982C4'}>{Math.round(weather.minTemp)}˚</Box>
            <Box color={'#808892'}>/</Box>
            <Box color={'#F94144'}>{Math.round(weather.maxTemp)}˚</Box>
            {/* {`${Math.round(weather.minTemp)} / ${Math.round(weather.maxTemp)}${temperatureUnit}`} */}
          </Box>
        </WeatherItemWrapper>
      </Box>
    </Box>
  );
};

const WeatherItemWrapper = styled.div`
  min-width: 80px;
  max-width: 80px;
  padding-top: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0.9;
  font-size: 14px;
`;
